export default function LanguagePartLabel({ code, label, altPart }) {
	if (altPart) {
		return (
			<span>
				<span lang={code}>{label}</span>{' '}
				<span lang={altPart.lang}>{altPart.text}</span>
			</span>
		);
	}

	return <span lang={code}>{label}</span>;
}
